import React, { useState, useEffect, useContext } from 'react';
import { AuthContext } from '../../contexts/AuthContext';
import Select from 'react-select';
import { RegisterContext } from '../../contexts/RegisterContext';
import * as referenceService from '../services/referenceService';




export function AdminAllConfirmed() {


    const { user } = useContext(AuthContext);
    const { schools } = useContext(RegisterContext);
    


    const [selectedSchool, setSelectedSchool] = useState(user.role == 'Director' ? { value: user.school.id } : null);
    const [resultData, setResultData] = useState([]);
    const [errmsg, setErrmsg] = useState(null);

    const convertedData = schools.map(item => ({
        value: item.id,
        label: item.shortName
    }));

    const addInfo = {
        value: 0,
        label: 'Всички училища'
    }

    convertedData.unshift(addInfo);

    document.title = `Всички потвърдени`;

    const handleChange = (selectedSchool) => {
        setSelectedSchool(selectedSchool);
    };

    const populate = async () => {

        try {
            await referenceService.getSchoolRanking(4, selectedSchool.value)
                .then((res) => {
                    if (res.status !== 400) {
                        setResultData(res);
                        if (res.length === 0) {
                            setErrmsg('Не са открити деца по тези критерии');
                        }
                    }
                })
        } catch (error) {


            if (error.message === 'Няма активно класиране!') {
                setErrmsg('Няма активно класиране!');
            }
            console.error('Error fetching data:', error.message);
        }


    };



    useEffect(() => {

        //if (user.role === 'Director') {
        //    setSelectedSchool({ value: user.school.id });
        //}
        populate();
    }, [selectedSchool]);





    return (
        <main id="main" className="main">

            <div className="pagetitle">
                <h1 className="use-font">Всички потвърдени </h1>
                <nav>
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item"><a href="/schadm">Начало</a></li>
                        <li className="breadcrumb-item active">Всички потвърдени</li>
                    </ol>
                </nav>
            </div>

            <section className="section dashboard">

                <div className="row">

                    <div className="col-lg-12">
                        <div className="row">
                            {(user.role === 'SuperAdmin' || user.role === 'Municipality' || user.role === 'Admin') ?
                                <div className="col-lg-2 w-40-l">
                                    <h3>Избери училище</h3>
                                    <Select
                                        value={selectedSchool}
                                        onChange={handleChange}
                                        options={convertedData}
                                        placeholder="Избери"
                                    />
                                </div>
                                : ''
                            }

                        </div>
                        <div className="row mt-5">
                            
                            {(selectedSchool && resultData.length > 0) ?
                                <table className="table table-striped table-hover w-100">
                                    <thead>
                                        <tr>
                                            <th scope="col">#</th>
                                            <th scope="col">ЕГН/ЛНЧ</th>
                                            <th scope="col">ИМЕ</th>
                                            <th scope="col">УЧИЛИЩЕ</th>
                                            <th scope="col">СТАТУС</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {

                                            resultData.map((r, index) => (
                                                <tr key={index + 1}>
                                                    <td>{index + 1}</td>
                                                    <td>{r.childEgn}</td>
                                                    <td>
                                                        {r.childName}
                                                        {r.childName2 && <br />}
                                                        {r.childName2}
                                                        {r.childName3 && <br />}
                                                        {r.childName3}
                                                        {r.childName4 && <br />}
                                                        {r.childName4}
                                                    </td>
                                                    <td>{r.schools[0]}</td>
                                                    <td>Потвърдено класиране</td>
                                                </tr>
                                            ))
                                        }
                                    </tbody>
                                </table>
                                : errmsg
                            }
                        </div>
                    </div>

                </div>

            </section>

        </main>
    )
}

export default AdminAllConfirmed;